import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/flaticon/001-schedule.svg'


const _hoisted_1 = {
  class: "container p-0 m-0",
  "data-kt-landing": "true"
}
const _hoisted_2 = { class: "divBlanco textoCentrado p-5 pb-2" }
const _hoisted_3 = { class: "fs-4 landingSubtitle2 m-3" }
const _hoisted_4 = { class: "divServicios mb-5" }
const _hoisted_5 = { class: "landingSubtitle textoCentrado pb-5 fw-bold" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "botonComWrap m-2 mb-5" }
const _hoisted_8 = { class: "form-floating my-5 derecha" }
const _hoisted_9 = {
  selected: "true",
  value: undefined
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "container m-0 p-0 text-center mt-10" }
const _hoisted_13 = {
  key: 0,
  class: "row row-cols-md-3 m-0 p-5 justify-content-center align-items-end"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "iconoServ",
  "mb-3": "",
  "mt-5": ""
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "mt-0 mb-3 fs-3"
}
const _hoisted_18 = { class: "p-4" }
const _hoisted_19 = { class: "card-body p-0" }
const _hoisted_20 = { class: "card-title cardTidle my-5" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  class: "card-text text-muted",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "iconoCalendario" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icono calendario"
  })
], -1)
const _hoisted_24 = { style: {"text-align":"center","margin-left":"10px"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "mt-20 textoServiciosColectivos"
}
const _hoisted_27 = {
  class: "row imgHomePage",
  ref: "info"
}
const _hoisted_28 = { class: "m-0 homeInfo align-content-center" }
const _hoisted_29 = { class: "landingInfoTextTitle d-flex pb-5 pr-5 text-center" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "icono fas fa-info-circle fa-2x" }, null, -1)
const _hoisted_31 = { class: "align-self-center colorTitle" }
const _hoisted_32 = { class: "landingInfoText" }
const _hoisted_33 = { class: "landingInfoText recuadro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.i18n("infoVerMas")), 1),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            class: "cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTo('info')))
          }, _toDisplayString(_ctx.i18n("masLink")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.i18n("serviciosInscripcionesAbiertasTitulo")), 1),
      _createElementVNode("div", {
        class: "textoCentrado landingSubtitle2 mx-10 fs-3",
        style: {"white-space":"pre-line"},
        innerHTML: _ctx.$t('descripcionServiciosInscripcionesAbiertas')
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            name: "comarca",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comarca) = $event)),
            class: "form-select btnFormComarcas sombra"
          }, [
            _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.i18n("OpcionVerTodasLasComarcas")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (comarca, i) => {
              return (_openBlock(), _createElementBlock("option", {
                value: comarca.id,
                key: i
              }, _toDisplayString(comarca.nombreCompuesto), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.comarca]
          ]),
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.i18n("DireccionComarcaLabel")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.datosServicios.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosServicios, (item, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("div", {
                  class: "card mb-3 pt-5 card-title tarjetaServicio mt-10 cursor-pointer",
                  onClick: ($event: any) => (_ctx.onItemTap(item))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: 
                '/media/iconos-servicios/' +
                (item.iconoCls
                  ? item.iconoCls.replace(/\s+/g, '-') + '.png'
                  : 'default.png')
              ,
                      alt: "{{item.iconoCls}}"
                    }, null, 8, _hoisted_16)
                  ]),
                  (!_ctx.comarca)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.comarca.nombre), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", _hoisted_20, [
                        _createElementVNode("div", {
                          innerHTML: item.nombre.toLowerCase().replace('(', '<br>(')
                        }, null, 8, _hoisted_21)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode(" Del " + _toDisplayString(_ctx.moment(item.servicio.inicioPrevisto).format("LL")), 1),
                      _hoisted_25,
                      _createTextVNode(" al " + _toDisplayString(_ctx.moment(item.servicio.finPrevisto).format("LL")), 1)
                    ])
                  ])
                ], 8, _hoisted_14)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createTextVNode(_toDisplayString(_ctx.loading
          ? _ctx.i18n("cargandoServiciosColectivosEnComarca")
          : _ctx.i18n("sinServiciosColectivosEnComarca")) + " ", 1),
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                  key: 0,
                  animationLink: "https://assets3.lottiefiles.com/packages/lf20_rc6CDU.json",
                  height: 200,
                  width: 200
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("h3", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.i18n("informacionGeneral")), 1)
        ]),
        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.i18n("planCorresponsablesInfo")), 1),
        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.i18n("planCorresponsablesObjetivos")), 1)
      ])
    ], 512)
  ], 64))
}